export default __webpack_public_path__ + "static/media/no-money.d62f6ef6.png";